import React, { useMemo } from 'react';
import MaterialTable from '@material-table/core';
import { TABLE_OPTIONS } from '../../../consts/tableOptions';
import useTableLocalization from '../../../utils/useTableLocalization';
import tableColumns from './tableColumns';

export function UsersTable({ users, from, clientId }) {
  const { localization } = useTableLocalization();

  const tableDefaultColumns = useMemo(() => {
    return tableColumns({ from, clientId });
  }, [from, clientId]);

  const options = {
    ...TABLE_OPTIONS.HISTORY
  };

  return (
    <MaterialTable
      columns={tableDefaultColumns}
      data={users}
      options={options}
      localization={localization}
    />
  );
}

export default UsersTable;
